import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, G } from 'react-native-svg';

const MB_SVG_Eye = React.memo(
  (props: {
    /**
     * The size of the component.
     */
    size?: number;

    /**
     * The color of the component.
     */
    color?: string;

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={props.size ?? 16} height={props.size ?? 16} viewBox="0 0 16 16" fill="none">
          <G strokeLinejoin="round" strokeLinecap="round" stroke={props.color ?? '#BAC0CA'}>
            <Path d="M.666 8s2.667-5.333 7.333-5.333C12.666 2.667 15.333 8 15.333 8s-2.667 5.333-7.334 5.333C3.333 13.333.666 8 .666 8z" />
            <Path d="M8 10a2 2 0 100-4 2 2 0 000 4z" />
          </G>
        </Svg>
      </View>
    );
  }
);

export { MB_SVG_Eye };
